<template>
    <form method="POST" action="/bestellung">
        <csrf />

        <section class="products">
            <div class="container">
                <div class="products__demo-button">
                    <get-a-demo-button></get-a-demo-button>
                </div>

                <div class="products__heading">

                    <span class="products__title-icon">
                        <img src="/images/icons/cart.svg" />
                    </span>

                    <span class="products__title">
                        {{ trans('products.title') }}
                    </span>
                </div>

                <div class="products__description">
                    {{ trans('products.description') }}
                </div>

                <product-tiles
                    :products="products"
                    :filter="filter"
                    @selected="productsSelected = true"
                    @none-selected="productsSelected = false"
                >
                </product-tiles>

                <page-control :label="trans('page-control.next')" :disabled="!productsSelected" button centered margin-bottom></page-control>

                <div class="products__footer">
                    {{ trans('products.price_note') }}
                </div>
            </div>
        </section>
    </form>
</template>

<script>
export default {
    props: {
        products: Array,
        filter: String,
    },

    data() {
        return {
            productsSelected: false,
        };
    },
}
</script>
